import { parseAotdFilename } from "../../components/aotd-gallery/galleryImages";
import type { AotdDay } from "./printsApi";

// How a day reads on the prints pages and the print faces' neighbours.

const MONTHS = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

/** The AOTD day from the file name (a claim before 04:50 UTC belongs to the day before). */
export function dayLabel(day: AotdDay): string {
  const key = parseAotdFilename(day.filename);
  if (key) return `${key.day} ${MONTHS[key.month]} ${key.year}`;
  const d = new Date(day.date);
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/** "+0.026s" under a minute, then "+44m 52s", then "+3h 05m". */
export function formatRaceOffset(ms: number): string {
  const sign = ms < 0 ? "-" : "+";
  const abs = Math.abs(ms);
  if (abs < 60_000) return `${sign}${(abs / 1000).toFixed(3)}s`;
  const s = Math.round(abs / 1000);
  if (s < 3600) return `${sign}${Math.floor(s / 60)}m ${String(s % 60).padStart(2, "0")}s`;
  return `${sign}${Math.floor(s / 3600)}h ${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}m`;
}

/** "🧙‍♂️.n450s", or the bare username when they have no emoji. */
export function authorLabel(day: Pick<AotdDay, "authorEmoji" | "createdBy">): string {
  return day.authorEmoji ? `${day.authorEmoji}.${day.createdBy}` : day.createdBy;
}
